import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflowRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-pages',
	path: '/secure/admin/workflows/:page',
};
